import { useState } from "react"
import { render } from "storyblok-rich-text-react-renderer"


import SbEditable from "@mkt/ui/components/common/SbEditable"
import Img from "@mkt/ui/components/common/Img"

import Card from '../Card/index.js'
import Slider from '../Slider/index.js'

import * as S from "./styles.js"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const Issuers = ({ blok }) => {
  const allIssuers = blok?.groups.map(({ group }) => group.map(item => item)).flat()
  const [activeIssuer, setActiveIssuer] = useState(allIssuers[0]);

  return (
    <SbEditable content={blok} css={S.wrapper}>
      <div css={S.issuers}>
        <div css={S.issuerSlider("mobile")}>
          <Slider
            title={blok?.title}
            subtitle={blok?.subtitle}
            numberOfSlides={allIssuers.length}
            fillEmptySpace={true}
            config={{
              mobile: {
                itemsPerView: 3,
                showSlidesTail: false,
                scrollBy: 'group',
                gap: 16,
              },
              tablet: {
                itemsPerView: 2,
                scrollBy: 'group',
                showSlidesTail: false,
                gap: 24,
              },
              desk: {
                itemsPerView: 3,
                scrollBy: 'group',
                showSlidesTail: false,
                gap: 24,
              },
            }}
          >
            {allIssuers.map((box, index) => (
              <div class="slide" key={`issuer-mobile-slider-${index}`}>
                <div
                  css={S.issuerCard(activeIssuer?.issuer === box?.issuer)}
                  onClick={() => setActiveIssuer(box)}
                >
                  <Img src={assertAssetURL(box?.icon.filename)} alt={box?.icon.alt} />
                </div>
              </div>
            ))}
          </Slider>

          <div css={S.content}>
            <p css={S.issuer}>{render(activeIssuer?.name)}</p>
            <p css={S.text}>{render(activeIssuer?.content)}</p>
          </div>
        </div>

        <div css={S.issuerSlider("desktop")}>
          <Slider
            title={blok?.title}
            subtitle={blok?.subtitle}
            numberOfSlides={blok?.groups.length}
            config={{
              mobile: {
                itemsPerView: 1,
                showSlidesTail: false,
                scrollBy: 'group',
                gap: 24,
              },
              tablet: {
                itemsPerView: 2,
                scrollBy: 'group',
                showSlidesTail: false,
                gap: 24,
              },
              desk: {
                itemsPerView: 3,
                scrollBy: 'group',
                showSlidesTail: false,
                gap: 24,
              },
            }}
          >
            {blok?.groups.map(({ group }, index) => {
              return (
                <div class="slide" key={`slide-${index}`}>
                  <div css={S.group}>
                    {
                      group.map((box, index) => (
                        <Card
                          key={`issuer-${index}`}
                          box={box}
                          divider={false}
                          padding={32}
                          header={
                            <div css={S.cardHeader}>
                              <Img src={assertAssetURL(box?.icon.filename)} alt={box?.icon.alt} />
                              <p css={S.cardTitle}>{render(box?.name)}</p>
                            </div>
                          }
                        />
                      ))
                    }
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    </SbEditable>
  )
}

export default Issuers
